/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {CategoryOutlined, ManageSearch, NotesOutlined, PhotoCameraBack} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_FECHA_DATOS,
    CASILLA_IMG,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import Dialogo_Producto from "../Dialogos/Dialogo_Producto";
import Dialogo_Variaciones from "../Dialogos/Dialogo_Variaciones";
import Dialogo_Producto_Imagenes from "../Dialogos/Dialogo_Producto_Imagenes";
import Dialogo_Producto_Informacion from "../Dialogos/Dialogo_Producto_Informacion";


const Seccion_Productos = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'productos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Producto,
        titulo: 'Detalles de la prenda',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoVariaciones, abrir: abrirVariaciones} = useDialogo({
        Componente: Dialogo_Variaciones,
        titulo: 'Variaciones',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoInformacion, abrir: abrirInformacion} = useDialogo({
        Componente: Dialogo_Producto_Informacion,
        titulo: 'Informacion Prenda',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoImagenes, abrir: abrirImagenes} = useDialogo({
        Componente: Dialogo_Producto_Imagenes,
        titulo: 'Imagenes Adicionales',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'variaciones':
                abrirVariaciones(data)
                break
            case 'informacion':
                abrirInformacion(data)
                break
            case 'imagenes':
                abrirImagenes(data)
                break
        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoVariaciones/>

                <DialogoInformacion/>

                <DialogoImagenes/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Prendas'}
                        descripcion={`${numeroFilas} prendas en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Productos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Portada',
        direccion: 'left',
        propiedad: 'img',
        size: 50,
        tipo: CASILLA_IMG

    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: 'Categoria y Tipo',
        direccion: 'left',
        titulo: 'categoria',
        propiedad: 'tipo',
        tipo: CASILLA_TITULO_DATO
    },

    {
        nombre: 'Variaciones',
        direccion: 'left',
        propiedad: 'variaciones',
        tipo: CASILLA_CONTAR_ARR
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Variaciones',
        id: 'variaciones',
        icono: CategoryOutlined
    },
    {
        nombre: 'Informacion',
        id: 'informacion',
        icono: NotesOutlined
    },
    {
        nombre: 'Imagenes',
        id: 'imagenes',
        icono: PhotoCameraBack
    },
]


